export default {"src":"/_next/static/media/img-bfy-4.34469b9a.svg","height":304,"width":817,"blurWidth":0,"blurHeight":0};